<template>
  <v-content>
    <v-overlay v-if="loadingOverlay === true">
      <div>Loading Page...</div>
    </v-overlay>
    <v-container>
      <h1 class="subheading grey--text">{{categoryName}}: {{leadCount}} Leads</h1>

      <v-simple-table>
        <thead>
          <tr>
            <th class="text-left">Brand</th>
             <th class="text-left">Platform</th>
            <th class="text-left">Followers</th>
            <th class="text-left">Engagement Rate</th>
             <th class="text-left"></th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="lead in leads" :key="lead._id">
            <td>@{{lead.instagramProfile}}</td>
             <td v-if="lead.isInstagram === true">Instagram</td>
            <td v-else>Facebook</td>
            <td>{{lead.followers}}</td>
            <td>{{(lead.engagementRate * 100).toFixed(2)}}%</td>
            <td v-if="lead.contacted === true">contacted</td>
            <td v-else>not contacted</td>
            <td>
              <v-btn :to="'/leads/detail/'+lead._id" small>View Lead</v-btn>

            </td>
          </tr>
        </tbody>
      </v-simple-table>
    </v-container>
  </v-content>
</template>
<script>
import firebase from "firebase";
import axios from "axios";
import { leadsSearchApi } from "@/config/appSettings";
export default {
  data: () => ({
    loadingOverlay: true,
    leads: null,
    categoryId: null,
    leadCount: null,
    categoryName : null,
    leadContated: null 
  }),
  name: "Leads",
  methods: {
    async loadCategories() {
      let userToken = firebase.auth().currentUser.uid;
      let leadSearchUrl = `${leadsSearchApi}${userToken}`
      //console.log(this.$route.params.categoryId)
      leadSearchUrl = `${leadSearchUrl}&limit=1000&category=${this.$route.params.categoryId}`
      let leadList = await axios.get(leadSearchUrl);

      //console.log("LEADS", leadList);
      if (leadList.data.success === true) {
        this.leads = leadList.data.result;
        this.leadCount = leadList.data.count 
        this.categoryName = leadList.data.category
      }
    },
    closeLoadingModal() {
      let self = this;

      setTimeout(function() {
        self.loadingOverlay = false;
      }, 1000);
    }
  },

  mounted() {
    this.loadCategories();
    this.closeLoadingModal();
  }
};
</script>

<style scoped>
</style>